module.exports = __webpack_public_path__ + "static/img/4.a0dbaa45.png";